import { pagesModule, buildBreadcrumbs } from '@/store/database/pagesModule';
import { contextsModule } from '@/store/database/contextsModule';
import { generateRandomId } from '@/magnetarSetup';
import { Timestamp, deleteField } from 'firebase/firestore';
import useContext from '@/views/Context/use/useContext';
import { currentUserId } from '@/store/useAuth';

/* ----------------------------- Page Functions ----------------------------- */
export const updatePage = ({ pageId, update }) => {
  pagesModule.doc(pageId).merge(update);
};

export const removeNotePages = ({
  noteId,
  pageId,
  keepNote = false,
  deleteNotes = true,
  forceDelete = false
}) => {
  //  TODO NEED TO CHECK IF IT'S SHARED, and if so
  //  we need to delete the note from every user panel
  console.log(pageId, noteId);
  const page = pagesModule.doc(pageId).data;
  const note = page.pageNotes[noteId];
  const notesPage = pagesModule.doc(note.pageId).data;
  //  remove the note
  if (!keepNote) {
    removeNoteFromPanel({ noteId, pageId });
  }
  //  if we are deleting notes, then assign all children pages to delete, too
  if (deleteNotes) {
    deleteBranch(notesPage, 0, forceDelete);
  }
};

export const addPage = async ({
  contextId,
  title = '',
  noWait = false,
  pageType = 0,
  pageNotes = {},
  flair = {}
}) => {
  console.log('addPage start');
  //get the id's that we will need
  let localContextId = contextId;
  const pageId = generateRandomId();

  if (localContextId == undefined) {
    const { activeContextId } = useContext();
    localContextId = activeContextId.value;
  }
  const userId = currentUserId.value;

  //  setup flair
  const defaultFlair = {
    enabled: [],
    progress: 0,
    check: false,
    likely: [0, 0],
    rating: 0
  };

  const newFlair = { ...defaultFlair, ...flair };
  //make a new page dataset
  const newPageData = {
    id: pageId,
    title,
    context: localContextId,
    type: pageType,
    flair: newFlair,
    createdBy: userId,
    createdOn: Timestamp.now(),
    pageNotes,
    toDelete: false
  };

  if (noWait) {
    console.log('no wait');
    pagesModule.doc(pageId).insert(newPageData);
    console.log('added page');
    return pageId;
  } else {
    await pagesModule.doc(pageId).insert(newPageData);
    return pageId;
  }
};

export const deleteBranch = (page, depth = 0, forceDelete) => {
  console.log(page);
  //  if page is archived or shared and we are not forceDelete, then stop
  //  this will keep errant deletes from removing shared stuff
  if (
    !forceDelete &&
    (page.isCard ||
      (page.onUserPanels && page.onUserPanels.filter(u => u != currentUserId.value).length))
  ) {
    return;
  }
  const embeddedPageNotes = Object.values(page.pageNotes).filter(
    n => !n.toDelete && n !== undefined && n.id
  );

  let dIds = [];

  if (embeddedPageNotes.length) {
    embeddedPageNotes.forEach(pn => {
      const page = pagesModule.doc(pn.pageId).data;
      dIds = [...dIds, ...deleteBranch(page, depth + 1)];
    });
  }
  const update = { toDelete: true };
  if (depth === 0) {
    //  check if there is a title
    const t = page.title;
    const tempDoc = new DOMParser().parseFromString(t, 'text/html');
    const title = tempDoc.body.textContent || '';

    //  get the children meta information
    const childs = [];
    Object.values(page.pageNotes).forEach(n => {
      if (n && n.id && !n.toDelete) {
        const cPage = pagesModule.doc(n.pageId).data;
        const t = cPage.title;
        const tempDoc = new DOMParser().parseFromString(t, 'text/html');
        let title = tempDoc.body.textContent || '';
        if (title.length > 43) title = title.slice(0, 40) + '...';
        const subChildren = [];
        Object.values(cPage.pageNotes).forEach(n => {
          if (n && n.id && !n.toDelete) {
            const cPage = pagesModule.doc(n.pageId).data;
            const t = cPage.title;
            const tempDoc = new DOMParser().parseFromString(t, 'text/html');
            let title = tempDoc.body.textContent || '';
            if (title.length > 20) title = title.slice(0, 17) + '...';
            if (title.length) {
              subChildren.push({ order: n.order, title, type: cPage.type, id: cPage.id });
            }
          }
        });

        childs.push({
          order: n.order,
          title,
          type: page.type,
          id: page.id,
          children: subChildren.sort((a, b) => a.order - b.order)
        });
      }
    });

    if (childs.length || title.length) {
      console.log(childs.length, title.length);
      //  there is some content here, save it as a deleteRoot
      update.childrenSummary = childs.sort((a, b) => a.order - b.order);
      //  get origin info
      const noteCardOrigin = buildBreadcrumbs(page.id);
      update.noteCardOrigin = noteCardOrigin;
      //  mark this as deleteRoot, so we can show it in trash can
      update.deleteRoot = true;
      update.deletedBy = currentUserId.value;
      update.deletedOn = new Date();
      update.deletedDescendants = dIds;
    }
  } else {
    dIds.push(page.id);
  }
  console.log(dIds);
  updatePage({ pageId: page.id, update });
  return dIds;
};

export const restoreBranch = pageId => {
  const page = pagesModule.doc(pageId).data;
  page.deletedDescendants.forEach(d => {
    const update = { toDelete: false };
    updatePage({ pageId: d, update });
  });
  const update = {
    toDelete: false,
    deleteRoot: null,
    deletedBy: null,
    deletedOn: null,
    deletedDescendants: null,
    notecardOrigin: null,
    childrenSummary: null
  };
  updatePage({ pageId, update });
  addNoteToTeammate({ addToSelf: true, pageId })
};
/* -------------------------  Archive Actions ------------------------- */

export const convertToCard = ({ pageId, groupId = null }) => {
  const noteCardOrigin = buildBreadcrumbs(pageId);
  const update = {
    noteCard: true,
    noteCardGroup: groupId,
    noteCardOrigin,
    noteCardCreated: Timestamp.now()
  };
  updatePage({ pageId, update });
};

export const changeCardGroup = ({ pageId, groupId = null }) => {
  const update = {
    noteCardGroup: groupId
  };
  updatePage({ pageId, update });
};

export const revertFromCard = ({ pageId }) => {
  const update = { noteCard: false };
  updatePage({ pageId, update });
};

export const revertFromArchive = ({ pageId, targetPageId }) => {
  const page = pagesModule.doc(pageId).data;
  // const context = contextsModule.doc(page.context).data;
  const currentUserPanels = page.onUserPanels || [];
  const panelSet = new Set(currentUserPanels);
  panelSet.add(currentUserId.value);

  const update = { onUserPanels: [...panelSet] };
  updatePage({ pageId, update });

  addNote({
    pageId: targetPageId,
    embeddedPageId: pageId
  });
};

/* --------------------------- Local Hide Actions --------------------------- */

export const unHideNote = ({ pageId, targetPageId }) => {
  const page = pagesModule.doc(pageId).data;

  // const context = contextsModule.doc(page.context).data;
  //  check if it's the old version of archive in place
  console.log(page.localArchives);
  if (page.localArchives && page.localArchives.includes(targetPageId)) {
    console.log('old archive');
    const currentUserPanels = page.onUserPanels || [];
    const panelSet = new Set(currentUserPanels);
    panelSet.add(currentUserId.value);
    const localArchives = page.localArchives ? page.localArchives : [];
    const localSet = new Set(localArchives);
    localSet.delete(targetPageId);
    const update = {};
    update.localArchives = [...localSet];
    update.onUserPanels = [...panelSet];
    updatePage({ pageId, update });
  } else {
    //  otherwise do it the right way and just remove the nested field
    const prop = 'hiddenNotes.' + pageId;
    console.log(targetPageId, prop);
    pagesModule.doc(targetPageId).deleteProp(prop);
  }

  addNote({
    pageId: targetPageId,
    embeddedPageId: pageId
  });
};

export const hideNote = ({ pageId, noteId, parentPageId }) => {
  //  Create a hiddenNotes object on the parentPageId
  const parentPage = pagesModule.doc(parentPageId).data;
  const hiddenNotes = parentPage.hiddenNotes ? parentPage.hiddenNotes : {};
  hiddenNotes[pageId] = { pageId, hideDate: Timestamp.now() };
  const update = {
    hiddenNotes
  };
  updatePage({ pageId: parentPageId, update });
  deleteNote({ noteId, pageId: parentPageId });

  // const page = pagesModule.doc(pageId).data;
  // const localArchives = page.localArchives ? page.localArchives : [];
  // const localSet = new Set(localArchives);
  // localSet.add(targetPageId);

  // const noteCardOrigin = buildBreadcrumbs(pageId);
  // const update = {
  //   localArchives: [noteCardOrigin[noteCardOrigin.length - 1].id],
  //   localArchiveDate: Timestamp.now()
  // };
  // updatePage({ pageId, update });
  // removeNoteFromPanel({{ noteId: noteId, pageId: targetPageId });
};

/* ------------------------------ Note Actions ------------------------------ */

export const deleteNote = ({ noteId, pageId }) => {
  const page = pagesModule.doc(pageId).data;
  const currentNoteBlock = page.pageNotes[noteId];
  if (!currentNoteBlock) {
    console.log('not current note block!');
    return false;
  }
  const siblingNotes = Object.values(page.pageNotes).filter(
    n => !n.toDelete && n !== undefined && n.id
  );
  const { order } = currentNoteBlock;
  const noteBlocksUpdate = {};
  siblingNotes.forEach(noteBlock => {
    if (noteBlock.order > order) {
      noteBlocksUpdate[noteBlock.id] = {
        order: noteBlock.order - 1
      };
    }
  });

  //mark to delete the field that we no longer need
  noteBlocksUpdate[noteId] = {};
  noteBlocksUpdate[noteId].toDelete = true;

  //update the orders if the object length is not 0
  if (Object.keys(noteBlocksUpdate).length !== 0) {
    updatePage({ pageId, update: { notesToDelete: true, pageNotes: noteBlocksUpdate } });
  } else {
    console.log('no order needed updated');
  }
};

export const addNoteToTeammate = ({ teammateId, pageId, addToSelf = false }) => {
  //  update page
  const page = pagesModule.doc(pageId).data;
  const context = contextsModule.doc(page.context).data;
  const targetUser = addToSelf ? currentUserId.value : teammateId;
  const targetPanelId = context.userPanels[targetUser];
  const currentUserPanels = page.onUserPanels || [];
  //  Make a set so we don't have to de dupe
  const panelSet = new Set(currentUserPanels);
  panelSet.add(currentUserId.value);
  if (teammateId) {
    panelSet.add(teammateId);
  }
  const update = { onUserPanels: [...panelSet] };
  console.log(update);
  updatePage({ pageId, update });

  //  add note
  addNote({
    pageId: targetPanelId,
    order: 0,
    embeddedPageId: pageId
  });
};

export const removeNoteFromPanel = ({ noteId, pageId }) => {
  //  remove a note from a user's panel
  const parentPage = pagesModule.doc(pageId).data;
  const note = parentPage.pageNotes[noteId];
  const page = pagesModule.doc(note.pageId).data;
  if (page) {
    const userPanels = page.onUserPanels || [];
    const userId = currentUserId.value;
    const newPanels = userPanels.filter(id => id !== userId);

    updatePage({
      pageId: page.id,
      update: { onUserPanels: newPanels }
    });
  }
  deleteNote({ noteId, pageId });
};

export const addNote = async ({
  pageId,
  order,
  pageType = 0,
  html = '',
  returnPageId = false,
  returnPageAndNoteId = false,
  embeddedPageId = false,
  embeddedNoteCardId = false,
  flair,
  x = 0,
  y = 0
}) => {
  console.log('addCardNote', order);

  if (pageId == undefined) {
    throw 'no pageId was provided for the new note';
  }

  const page = pagesModule.doc(pageId).data;
  // get the sibling note blocks to determine last item order and to update order later
  const siblingNotes = Object.values(page.pageNotes)
    .filter(n => !n.toDelete && n !== undefined && n.id)
    .sort((a, b) => (a.order > b.order ? 1 : -1));

  let updatedOrder = false;
  const orders = siblingNotes.map((n, i) => ({ id: n.id, order: n.order, index: i }));
  console.log(orders);
  //  check if orders are off
  if (orders.find(n => n.order !== n.index)) {
    console.log('fix orders');
    //  just fix them all
    siblingNotes.forEach((n, i) => {
      n.order = i;
    });
    updatedOrder = true;
  }

  const newOrder = order !== undefined ? order : siblingNotes.length;

  //get necessary Id's (generated for new Id and user ID for created by)
  const id = generateRandomId();
  const userId = currentUserId.value;

  //create the update object for the addition of the note
  const noteUpdate = {};
  noteUpdate[id] = {
    id,
    createdBy: userId,
    createdOn: Timestamp.now(),
    updatedOn: Timestamp.now(),
    order: newOrder,
    pageId: false,
    noteCardId: embeddedNoteCardId,
    toDelete: false,
    type: 'card',
    x,
    y,
    content: {
      html,
      widgetType: null,
      widgetData: {}
    }
  };

  let newPageId;

  //  if not an embeddedNoteCard then setup the pageId
  if (!embeddedNoteCardId) {
    if (embeddedPageId) {
      newPageId = embeddedPageId;
    } else {
      newPageId = await addPage({
        section: false,
        order: 0,
        title: html,
        flair,
        noWait: true,
        pageType,
        contextId: page.context
      });
    }
    noteUpdate[id].pageId = newPageId;
  }
  console.log('new page', newPageId);
  //update all the other notes that have a greater order than the one being added to be +1
  siblingNotes.forEach(noteBlock => {
    if (noteBlock.order >= newOrder) {
      noteUpdate[noteBlock.id] = {
        order: noteBlock.order + 1
      };
    } else if (updatedOrder) {
      noteUpdate[noteBlock.id] = {
        order: noteBlock.order
      };
    }
  });

  updatePage({ pageId, update: { pageNotes: noteUpdate } });
  console.log('done');
  if (returnPageId) {
    return newPageId;
  } else if (returnPageAndNoteId) {
    return { pageId: newPageId, noteId: id };
  } else {
    return id;
  }
};

export const updateNote = ({ pageId, noteId, update }) => {
  const noteUpdate = {};
  const id = noteId;
  noteUpdate[id] = {
    ...update
  };
  updatePage({ pageId, update: { pageNotes: noteUpdate } });
};

export const moveNotes = async ({ noteIds, moveToPageId, moveFromPageId, moveToPosition }) => {
  if (noteIds.constructor !== Array) {
    throw 'input ordersToMove was either not provided or is not an array please check your function inputs and try again';
  }
  if (isNaN(moveToPosition)) {
    throw 'moveLocation was either not provided or is not a number please check your function inputs and try again';
  }
  if (moveToPageId == undefined) {
    throw 'input pageId was either not provided or undefined please check your function inputs and try again';
  }
  console.log(noteIds, moveToPageId, moveFromPageId, moveToPosition);

  //get the noteBlocks we are intersted in and convert them to an array
  const page = pagesModule.doc(moveFromPageId).data;
  const fromDomainId = page.context;
  const pageNotes = page.pageNotes;
  const notesToMove = noteIds.map(n => pageNotes[n]).filter(n => n != undefined);

  const firstNoteOriginalOrder = notesToMove[0].order;
  const lastNoteOriginalOrder = notesToMove[notesToMove.length - 1].order;

  const toPage = pagesModule.doc(moveToPageId).data;

  //  Check if moving to a different context
  if (toPage.context !== fromDomainId) {
    console.log('Trying to move into a different context. We dont do that yet.');
    return;
  }
  const moveToPageNotes = Object.values(toPage.pageNotes)
    .filter(n => !n.toDelete && n !== undefined && n.id)
    .sort((a, b) => {
      return a.order > b.order ? 1 : -1;
    });

  const update = {};

  const ordersMap = moveToPageNotes.map((n, i) => ({ id: n.id, order: n.order, index: i }));
  //  check if orders are off
  if (ordersMap.find(n => n.order !== n.index)) {
    console.log('fix orders');
    //  just fix them all
    moveToPageNotes.forEach((n, i) => {
      n.order = i;
      update[n.id] = { order: n.order };
    });
  }

  const toUpdate = {};
  if (moveToPageId == moveFromPageId) {
    console.log('move within page');
    //  we are moving notes within the same card
    if (moveToPosition < firstNoteOriginalOrder) {
      console.log('moving up page');
      // we are moving notes up the page
      const notesToAdjust = moveToPageNotes.filter(
        n => n.order < firstNoteOriginalOrder && n.order >= moveToPosition
      );
      //  Check there is not a problem with order
      notesToAdjust.forEach(n => {
        update[n.id] = { order: n.order + notesToMove.length };
      });
      notesToMove.forEach((n, i) => {
        update[n.id] = { order: moveToPosition + i };
      });
    } else if (moveToPosition > lastNoteOriginalOrder) {
      console.log('moving down page');
      //  we are moving notes down the page
      const notesToAdjust = moveToPageNotes.filter(
        n => n.order > lastNoteOriginalOrder && n.order <= moveToPosition
      );
      notesToAdjust.forEach((n, i) => {
        update[n.id] = { order: n.order - notesToMove.length };
      });
      notesToMove.forEach((n, i) => {
        update[n.id] = { order: moveToPosition - (notesToMove.length - 1) + i };
      });
    } else {
      //  we are moving within the selected notes.
      return;
    }
  } else {
    console.log('move to new page');
    // we a moving notes to a different card
    const moveFromPageNotes = Object.values(pageNotes).filter(
      n => !n.toDelete && n !== undefined && n.id
    );
    // setup the cards that will move
    const orderedNotesToMove = notesToMove.sort((a, b) => (a.order > b.order ? 1 : -1));

    // delete notes from fromPage
    orderedNotesToMove.forEach(n => {
      update[n.id] = { toDelete: true };
    });
    // fix the order of the moveFromCard notes
    moveFromPageNotes.forEach(n => {
      if (n.order > lastNoteOriginalOrder) {
        update[n.id] = { order: n.order - noteIds.length };
      }
    });

    // add notes to toPage
    orderedNotesToMove.forEach((n, i) => {
      const id = n.id;
      toUpdate[id] = {
        ...n,
        updatedOn: Timestamp.now(),
        order: moveToPosition + i,
        toDelete: false
      };
    });

    // fix the order of the moveToCard notes
    moveToPageNotes.forEach(n => {
      if (n.order >= moveToPosition) {
        toUpdate[n.id] = { order: n.order + noteIds.length };
      }
    });
  }

  //send the update to vuex and firestore
  if (Object.keys(update).length !== 0) {
    updatePage({ pageId: moveFromPageId, update: { pageNotes: update } });
    if (Object.keys(toUpdate).length !== 0) {
      updatePage({ pageId: moveToPageId, update: { pageNotes: toUpdate } });
    }
  } else {
    throw 'problems generating the update object please check that the moveLocation input value is not included in the ordersToMove Input Array';
  }
};

export const duplicateNotes = ({
  noteIds,
  startingPosition,
  fromPageId,
  toPageId,
  shallow = false,
  replaceNote
}) => {
  const toPage = pagesModule.doc(toPageId).data;
  const contextId = toPage.context;
  //-------------------------------FUNCTIONS----------------------------
  //  Add a duplicate page to the db. clone any notes first. return the new page id;
  const duplicatePage = async pageId => {
    const oldPage = pagesModule.doc(pageId).data;
    if (!oldPage) {
      console.error('could not find old page to duplicate', pageId);
      return false;
    }
    console.log('duplicate', pageId, oldPage);
    //  go through it's notes and update
    const oldPageNotes = Object.values(oldPage.pageNotes).filter(
      pn => !pn.toDelete && pn.id && pn !== undefined
    );
    const newPageNotes = {};
    if (oldPageNotes.length) {
      console.log('has notes, clone them!');
      const notePromises = [];
      oldPageNotes.forEach(opn => {
        notePromises.push(cloneNote(opn));
      });
      const newNotes = await Promise.all(notePromises);
      console.log(newNotes);
      newNotes.forEach(n => {
        if (n) {
          newPageNotes[n.id] = n;
        }
      });
    }
    console.log('done clone', newPageNotes);
    const newPageId = await addPage({
      order: 0,
      title: oldPage.title,
      noWait: true,
      pageType: oldPage.type,
      flair: oldPage.flair,
      pageNotes: newPageNotes,
      contextId: contextId
    });

    return newPageId;
  };

  //  copy note data, run duplicate page if there is a page, return the whole new note
  const cloneNote = async note => {
    const newNote = { ...note };
    //  duplicate the note page
    if (newNote.pageId) {
      const newPageId = await duplicatePage(newNote.pageId);
      if (!newPageId) {
        return false;
      }
      newNote.pageId = newPageId;
    }
    const newId = generateRandomId();
    newNote.id = newId;
    return newNote;
  };

  //-------------------------------MAIN----------------------------
  //  for each noteId get the notes
  const fromPage = pagesModule.doc(fromPageId).data;
  const notes = noteIds
    .map(n => fromPage.pageNotes[n])
    .sort((a, b) => (a.order < b.order ? -1 : 1));

  //  Check if pasting into an empty note
  if (replaceNote) {
    const targetPage = pagesModule.doc(toPageId).data;
    const targetPageNotes = Object.values(targetPage.pageNotes);
    const noteToRemove = targetPageNotes.find(n => n.order == startingPosition && !n.toDelete);
    removeNotePages({
      noteId: noteToRemove.id,
      pageId: toPageId
    });
  }

  if (!shallow) {
    //  get each note page
    notes.forEach((n, index) => {
      duplicatePage(n.pageId)
        .then(newPageId => {
          addNote({
            pageId: toPageId,
            html: n.content ? n.content.html : '',
            embeddedPageId: newPageId,
            type: n.type,
            widgetInfo: { widgetType: n.content.widgetType, widgetData: n.content.widgetData },
            order: startingPosition + index
          });
        })
        .catch(e => console.error('problem duplicating page', e));
    });
  } else {
    notes.forEach((n, index) => {
      addNote({
        pageId: toPageId,
        html: n.content ? n.content.html : '',
        embeddedPageId: n.pageId,
        type: n.type,
        widgetInfo: { widgetType: n.content.widgetType, widgetData: n.content.widgetData },
        order: startingPosition + index
      });
    });
  }
};
